import {
  FETCH_TEST_SUCCESS,
  SET_GROUP_QUESTION,
  SET_CURRENT_PAGE,
  SET_TEST_PROCESS,
  SET_TEST_RESULT,
  RESET_DATA_TEST,
} from 'app/constants/tests';
import { Test, Group } from 'types/test';

export const setTest = (test: Test) => ({
  type: FETCH_TEST_SUCCESS,
  payload: test
});

export const resetDataTest = () => ({
  type: RESET_DATA_TEST,
});

export const setProcess = (process: string) => ({
  type: SET_TEST_PROCESS,
  payload: process
});

export const setGroupQuestions = (groupQuestions: Group[]) => {
  return {
    type: SET_GROUP_QUESTION,
    payload: groupQuestions,
  }
};

export const setResult = (result: Test) => ({
  type: SET_TEST_RESULT,
  payload: result
});

export const setCurrentPage = (page: number = 1) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: page,
  }
};
